import { isResourceListQueryKey, isResourceListContextSearchQueryKey } from './queryKeyGuards.js';

const filterOptionsTypeToResourceTypes = (type) => {
  switch (type) {
    case "webnote":
      return [
        "page",
        "text",
        "image"
      ];
    case "notepad":
      return [
        "notepad"
      ];
    case "file":
      return [
        "stored_file"
      ];
    case "folder":
      return [
        "folder"
      ];
    default:
      return [];
  }
};
const resourceMatchesFamilyFilter = (resource, family) => {
  switch (family) {
    case "highlight":
      return [
        "bookmark",
        "text",
        "image"
      ].includes(resource.kind);
    case "page":
      return [
        "bookmark"
      ].includes(resource.kind);
    case "notepad":
      return [
        "notepad"
      ].includes(resource.kind);
    case "image":
      return resource.kind === "image";
    case "generic_file":
      return [
        "video",
        "audio",
        "default",
        "document"
      ].includes(resource.kind);
  }
  return false;
};
const resourceMatchesFilterQuery = (resource, options) => {
  if (!options) return true;
  if (options.label && options.label !== options.label) {
    return false;
  }
  if (options.rootId && options.rootId !== resource.root?.id) {
    return false;
  }
  if (options.tagIds && !options.tagIds.some((tag) => resource.tags.some((resourceTag) => resourceTag.id === tag))) {
    return false;
  }
  if (options.kind && !options.kind.includes(resource.kind)) {
    return false;
  }
  return true;
};
const resourceMatchesSearchQuery = (resource, options) => {
  if (!options) return true;
  if (options.filters?.family && !options.filters.family.some((family) => resourceMatchesFamilyFilter(resource, family))) return false;
  if (options.filters?.tagIds && !options.filters?.tagIds?.some((tag) => resource.tags.some((resourceTag) => resourceTag.id === tag))) return false;
  if (options.filters?.type && !options.filters.type.flatMap(filterOptionsTypeToResourceTypes).includes(resource.kind)) return false;
  if (options.filters?.rootId && !options.filters?.rootId?.some((list) => resource.root?.id === list)) return false;
  return true;
};
const resourceMatchesQueryFilters = (resource, queryKey) => {
  if (isResourceListQueryKey(queryKey) && !!queryKey[1]) {
    return resourceMatchesFilterQuery(resource, queryKey[1]);
  }
  if (isResourceListContextSearchQueryKey(queryKey) && !!queryKey[1]) {
    return resourceMatchesSearchQuery(resource, queryKey[1]);
  }
  return false;
};

export { resourceMatchesQueryFilters };
//# sourceMappingURL=resourceMatchesQueryFilters.js.map
